module.exports = __webpack_public_path__ + "static/img/Inspection13.a97cbdfe.png";